import { AudioLines, Box, Clapperboard, Layers3, PanelLeftClose, Settings } from 'lucide-react';
import { useEditorStore, type Workspace } from '../../store/editorStore';

const workspaces: Array<{ id: Workspace; label: string; icon: typeof Clapperboard }> = [
  { id: 'video', label: 'Edit', icon: Clapperboard },
  { id: 'motion', label: 'Motion', icon: Layers3 },
  { id: '3d', label: '3D', icon: Box },
  { id: 'audio', label: 'Audio', icon: AudioLines }
];

export function WorkspaceRail() {
  const workspace = useEditorStore((state) => state.workspace);
  const setWorkspace = useEditorStore((state) => state.setWorkspace);
  const setModal = useEditorStore((state) => state.setModal);
  return <nav className="workspace-rail" aria-label="Workspaces">
    <div className="rail-tools">
      {workspaces.map(({ id, label, icon: Icon }) => <button key={id} className={workspace === id ? 'is-active' : ''} onClick={() => setWorkspace(id)} title={`${label} workspace`}><Icon size={19} /><span>{label}</span></button>)}
    </div>
    <div className="rail-bottom">
      <button title="Collapse panel"><PanelLeftClose size={18} /></button>
      <button title="Settings" onClick={() => setModal('settings')}><Settings size={18} /></button>
    </div>
  </nav>;
}
